/**
 * Component: sa-static-img-text
 * Description: Static Image with Title and Subtitle
 */
if (!customElements.get('sa-static-img-text')) {
  class SaStaticImgText extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Logic if needed
    }

    disconnectedCallback() {
    }
  }

  customElements.define('sa-static-img-text', SaStaticImgText);
}
